
import { Vue, Component } from 'vue-property-decorator';
// import Uploader from '@/components/next/Uploader.vue';
import Uploader from '../components/NewUploader.vue';
import qs from 'qs';
import { save, getRule, getBaseInfo } from '../api';
import { isWeiXin } from '@/common/ts/common';
import { FileType } from '@/common/ts/enum';
import {
  Field,
  CellGroup,
  Toast,
  Popup,
  Picker,
} from 'vant';
Vue.use(Field)
  .use(CellGroup)
  .use(Popup)
  .use(Picker);
@Component({
  components: {
    Uploader,
  },
})
export default class Save extends Vue {
  FileType = FileType;
  submitting = false;
  uploaderKey = 0;

  name: string = '';
  phone: string = '';
  title: string = '';
  instream: number = 0;
  instreamList: string[] = [
    '请选择',
    '小学组（6-12岁青少年）',
    '初中组（13-15岁青少年）',
    '高中组（16-18岁青少年）',
  ];
  showInstreamPicker: boolean = false;
  get instreamText(): string {
    return this.instreamList[this.instream] || '';
  }
  get instreamDefaultIndex(): number {
    return this.instream;
  }
  year: string = '';
  school: string = '';
  introduction: string = '';
  imgSrc: any = [];
  unionid: string | null = '';
  downLoadUrl: string =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  rulecontent: any = '';
  baseInfo: any = {};

  async uploadImg() {
    let uploadRes: string[] = [];
    if (this.$refs.imageUploader) {
      uploadRes = (await (
        this.$refs.imageUploader as Uploader
      ).uploadToOss()) as string[];
    }
    this.imgSrc = uploadRes;
  }

  async mounted() {
    const ret = await getRule();
    this.rulecontent = ret.data;
    const ret1 = await getBaseInfo();
    this.baseInfo = ret1.data;
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
  }
  AppLogin() {
    if (!window.token) {
      window.openApp('mUserLogin');
      return;
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  onInstreamConfirm(value: string, index: number) {
    this.instream = index;
    this.showInstreamPicker = false;
  }

  clearForm() {
    this.name = '';
    this.phone = '';
    this.title = '';
    this.instream = 0;
    this.year = '';
    this.school = '';
    this.introduction = '';
    this.imgSrc = [];
    this.uploaderKey++;
  }

  async submit() {
    if (this.submitting) return;

    if (!isWeiXin() && !window.udid) {
      this.$dialog
        .confirm({
          title: '友情提示',
          message: '请在上游新闻App进行报名',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
        .then((action) => {
          console.log(action);
          window.location.href = this.downLoadUrl;
        })
        .catch((action) => {
          console.log(action);
          if (action === 'overlay') {
            // 忽略掉点击遮罩层的关闭行为
            return;
          }
        });
      return;
    } else if (!this.name) {
      Toast('请填写姓名！');
      return false;
    } else if (!this.phone) {
      Toast('请填写电话！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (!this.title) {
      Toast('请填写作品名称！');
      return false;
    } else if (!this.instream) {
      Toast('请选择组别！');
      return false;
    } else if (!this.year) {
      Toast('请填写年龄！');
      return false;
    } else if (!this.introduction) {
      Toast('请填写简介！');
      return false;
    } else if (!this.imgSrc.length) {
      Toast('请上传图片！');
      return false;
    } else {
      this.submitting = true;
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0,
      });

      try {
        const data: any = {
          name: this.name,
          phone: this.phone,
          title: this.title,
          instream: this.instream,
          year: this.year,
          school: this.school,
          introduction: this.introduction,
          unionid: this.unionid,
          token: window.token,
          appkey: window.appkey,
          udid: window.udid,
          cover: this.imgSrc.join('|'),
        };
        const res: any = await save(data);
        Toast.clear();
        if (res.code === 200) {
          Toast(`${res.msg}`);
          this.clearForm();
          this.$router.push(`user`);
        } else {
          if (res.code === 505) {
            localStorage.removeItem('unionid');
            window.location.reload();
          } else {
            Toast(`${res.msg}`);
          }
        }
      } catch (error) {
        Toast.clear();
        Toast('网络错误，请稍后重试');
      } finally {
        this.submitting = false;
      }
    }
  }
}
